import React, { useState } from 'react';
import { Contact } from '../types/Contact';
import { StateAbbreviations } from '../types/States';
import Col100 from './Col100';
import Header from './Header';
import Processing from './Processing';
import { dynamicsService } from '../services/DynamicsService';


type Props = {
  onComplete: (() => void);
  client: Contact;
  primaryContact: Contact | undefined;
};
export default function ReleaseInformation(props: Props): JSX.Element {
    const { onComplete, client, primaryContact } = props;
    const [inputs, setInputs] = useState({
        agree: false,
    });
    const [submitted, setSubmitted] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const [error, setError] = useState(false);
    const [warning, setWarning] = useState<string>();
    const [clientID, setClientID] = useState<string>();
    const [loading, setLoading] = useState(true);
    // Accessors
    const { agree } = inputs;
    // Event Handlers
    function handleChange(e: React.ChangeEvent<HTMLInputElement>) {
        const { name, checked } = e.target;
        // setIsDirty(true);
        setInputs(inputs => ({ ...inputs, [name]: checked }));
    }
    function handleSubmit(e: React.FormEvent) {
        console.log("handleSubmit", e);
        e.preventDefault();
        // TODO Validation
        setSubmitted(true);
        if (!agree) {
            setWarning("You must agree to the release of information in order to schedule your SafeHaven 360 Plan audit.");
            return;
        }

        // TODO submit
        
        // Advance to Step 4 by calling the onComplete callback handler in App
        setSubmitting(true);
        onComplete();
        // dynamicsService.createOrUpdateClient(contact)
        //     .then((clientContact) => {
        //         setClientID(clientContact);
        //         setLoading(false);
        //     });
       
    }
    if (error) {
      return <Col100>
          <Header>Error!</Header>
          <div className="elementor-element elementor-widget elementor-widget-text-editor" data-element_type="widget" data-widget_type="text-editor.default">
            <div className="elementor-widget-container">
              <div className="elementor-text-editor elementor-clearfix">
                <p>
                  We're sorry-- but there was a problem collecting your contact information. Please go back, and try again.
                </p>
              </div>
            </div>
          </div>
        </Col100>;
    }

    if (submitting) {
        return (<Col100><Processing /></Col100>);
    }
    return <Col100>
        <Header>Release of Information</Header>
        <div className="elementor-element elementor-widget elementor-widget-text-editor" data-element_type="widget" data-widget_type="text-editor.default">
          <div className="elementor-widget-container">
            <div className="elementor-text-editor elementor-clearfix">
              <p>
                I, <u>
                  {client.firstName} {client.lastName}
                </u> authorize <strong>DwellAssured</strong> to use and release my personal information including my Name, Home Address, and Phone Number, disclosed during <strong>DwellAssured</strong>'s SafeHaven 360 Plan for, or to satisfy fulfillment of, solutions as part of the <strong>DwellAssured SafeHaven Membership</strong>.
              </p>
              <p>
                The health information that may be disclosed with my SafeHaven RN and Occupational Therapist Guides is protected and used solely to develop my <strong>DwellAssured SafeHaven 360 Plan</strong>.
              </p>
            </div>
          </div>
        </div>
        {primaryContact && <div className="mt-2 elementor-element elementor-widget elementor-widget-text-editor" data-element_type="widget" data-widget_type="text-editor.default">
            <div className="elementor-widget-container">
              <div className="elementor-text-editor elementor-clearfix">
                <p>
                  I, <u>
                    {client.firstName} {client.lastName}
                  </u>, authorize <strong>DwellAssured</strong> to share the results of my SafeHaven 360 Plan with <u>
                    {primaryContact.firstName} {primaryContact.lastName}
                  </u>.
                </p>
              </div>
            </div>
          </div>}
        <form onSubmit={handleSubmit} className="mt-2 order-form elementor-form" id="orderForm" name="OrderForm">
          <div className="elementor-element elementor-widget elementor-widget-text-editor" data-element_type="widget" data-widget_type="text-editor.default">
            <div className="elementor-widget-container">
              <div className="elementor-text-editor elementor-clearfix">
                <p>
                  I confirm that I have read and understand the terms and conditions of <strong>DwellAssured's Release of Information Agreement</strong>, and I understand that I have a right to object to information sharing of my information.
                </p>
              </div>
            </div>
          </div>
          <div className="elementor-form-fields-wrapper elementor-labels-">
            <div className="elementor-field-type-checkbox elementor-field-group elementor-column elementor-col-100">
              <label htmlFor="agree" className="elementor-field-label elementor-screen-only">
                I Agree to this release of information
              </label>
              <div className="elementor-field-subgroup  ">
                <span className="elementor-field-option cb-label">
                  <input type="checkbox" value="I Agree to this release of information" id="agree" name="agree" onChange={handleChange} />
                  <label htmlFor="agree" style={{ marginLeft: ".25rem" }}>
                    I Agree to this release of information
                  </label>
                </span>
              </div>
            </div>
            {/* <div className="elementor-field-type-checkbox elementor-field-group elementor-column elementor-col-50">
              <label htmlFor="notagree" className="elementor-field-label elementor-screen-only">
                I Do Not Agree
              </label>
              <div className="elementor-field-subgroup  ">
                <span className="elementor-field-option cb-label">
                  <input type="radio" value="I Do Not Agree" id="notagree" name="agree" onChange={handleChange} />
                  <label htmlFor="notagree" style={{ marginLeft: ".25rem" }}>
                    I Do Not Agree
                  </label>
                </span>
              </div>
            </div> */}
            {warning && <div className="mt-2" data-element_type="widget" data-widget_type="text-editor.default">
                <div className="elementor-widget-container">
                  <div className="elementor-text-editor elementor-clearfix">
                    <p className="text-danger">
                      {warning}
                    </p>
                  </div>
                </div>
              </div>}
            <div className="mt-2 d-flex">
              <button type="submit" className="et_pb_button et_pb_button_0 et_pb_bg_layout_light flex-grow-1">
                <span className="elementor-button-text mr-1">Next</span>
                <i aria-hidden="true" className="fas fa-angle-right" />
              </button>
            </div>
          </div>
        </form>
      </Col100>;
}